import { titleTheme,pageTheme,headerTheme,subTheme,contentTheme,cardTheme} from '../../components/consoleTheme'


import { useState } from "react"
import styled from "styled-components"
import { FeatureGuideOverview } from "./FeatureGuideOverview"
import {
  Network, HardDrive, Zap, Boxes, Database, Box, CreditCard, Copy, Rocket, Terminal, MonitorPlay, ListChecks,
} from "lucide-react"

function copyText(t) {
  if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(t).catch(() => fb(t)); else fb(t)
}
function fb(t) { const a = document.createElement("textarea"); a.value = t; a.style.position = "fixed"; a.style.opacity = "0"; document.body.appendChild(a); a.select(); try { document.execCommand("copy") } catch (_) {} document.body.removeChild(a) }

const Page = styled.div`
 ${pageTheme}
padding:0; background:#f8fafc; min-height:100vh;`
const Header = styled.header`
 ${headerTheme}
padding:1rem 2rem; background:#fff; border-bottom:1px solid #e2e8f0;@media(max-width:768px){padding:1rem;}`
const Title = styled.h1`
 ${titleTheme}
font-size:1.25rem; font-weight:600; color:#1e293b;`
const Sub = styled.p`
 ${subTheme}
margin:.25rem 0 0; font-size:.8rem; color:#94a3b8;`
const Content = styled.div`
 ${contentTheme}
padding:2rem; max-width:920px;@media(max-width:768px){padding:1rem;}`
const TabBar = styled.div`overflow-y:hidden;display:flex; gap:.25rem; flex-wrap:wrap; border-bottom:1px solid #e2e8f0; margin-bottom:1.5rem;`
const TabBtn = styled.button`display:inline-flex; align-items:center; gap:.4rem; padding:.6rem 1rem; background:none; border:none; cursor:pointer; font-size:.9rem; font-weight:${(p) => (p.active ? 600 : 500)}; color:${(p) => (p.active ? "var(--accent)" : "#64748b")}; border-bottom:2px solid ${(p) => (p.active ? "var(--accent)" : "transparent")}; margin-bottom:-1px; &:hover{color:var(--accent);}`
const Card = styled.div`
 ${cardTheme}
background:#fff; border:1px solid #e2e8f0; border-radius:.6rem; padding:1.5rem 1.75rem; margin-bottom:1.25rem;@media(max-width:768px){padding:1rem;}`
const H = styled.h2`font-size:1.05rem; font-weight:700; color:#1e293b; margin:0 0 .25rem; display:flex; align-items:center; gap:.5rem;`
const Lead = styled.p`color:#64748b; font-size:.9rem; margin:0 0 1.2rem; line-height:1.6;`
const Step = styled.div`margin-bottom:1.3rem;`
const StepTitle = styled.h3`display:flex; align-items:center; gap:.6rem; font-size:.95rem; font-weight:700; color:#1e293b; margin:0 0 .5rem;
  .n{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:var(--accent);color:#fff;font-size:.78rem;flex-shrink:0;}`
const Body = styled.div`padding-left:2rem; color:#475569; font-size:.88rem; line-height:1.65; ul{margin:.3rem 0;padding-left:1.1rem;} li{margin:.2rem 0;} b{color:#1e293b;}@media(max-width:768px){padding-left:0;}`
const Mono = styled.code`font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.82rem; color:#334155; background:#f1f5f9; padding:1px 5px; border-radius:4px;`
const Cmd = styled.div`display:flex; align-items:center; justify-content:space-between; gap:.75rem; background:#0f172a; color:#e2e8f0; border-radius:6px; padding:.6rem .85rem; margin:.4rem 0; font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.8rem; overflow-x:auto; button{background:none;border:none;color:#94a3b8;cursor:pointer;flex-shrink:0;&:hover{color:#fff;}}`
const Note = styled.div`display:flex; gap:.6rem; padding:.85rem 1rem; border-radius:8px; font-size:.84rem; line-height:1.55; background:#eff6ff; border:1px solid #bfdbfe; color:#1e40af; margin:.4rem 0;`

function C({ children }) { return <Cmd><span>{children}</span><button onClick={() => copyText(children)} title="복사"><Copy size={14} /></button></Cmd> }
const S = ({ n, title, children }) => <Step><StepTitle><span className="n">{n}</span> {title}</StepTitle><Body>{children}</Body></Step>

const TABS = [
  { key: "features", label: "기능별 사용·등록", icon: ListChecks },
  { key: "start", label: "시작하기 · 온프레 연결", icon: Rocket },
  { key: "storage", label: "스토리지", icon: HardDrive },
  { key: "serverless", label: "서버리스", icon: Zap },
  { key: "ansible", label: "오케스트레이션", icon: Boxes },
  { key: "db", label: "데이터베이스", icon: Database },
  { key: "registry", label: "컨테이너 레지스트리", icon: Box },
  { key: "rtremote", label: "RT Remote 원격제어", icon: MonitorPlay },
  { key: "billing", label: "결제 · 토큰", icon: CreditCard },
]

const Guide = () => {
  const [tab, setTab] = useState("features")
  return (
    <Page>
      <Header><Title>가이드</Title><Sub>온프레미스 연결과 각 기능 사용법</Sub></Header>
      <Content>
        <TabBar>
          {TABS.map((t) => { const I = t.icon; return (
            <TabBtn key={t.key} active={tab === t.key} onClick={() => setTab(t.key)}><I size={15} /> {t.label}</TabBtn>
          )})}
        </TabBar>

        {tab === "features" && <FeatureGuideOverview />}

        {tab === "start" && (
          <Card>
            <H><Network size={18} /> 온프레미스 연결 (VPC 에이전트)</H>
            <Lead>내 사무실/집의 서버·PC를 스카이넷 콘솔로 끌어오려면, 그 장비를 <b>SkynetMesh VPC</b>에 합류시킵니다.
              공인IP·포트포워딩 없이 아웃바운드 터널로 안전하게 연결되고, 가상IP(100.77.x.x)를 받아 LAN처럼 동작합니다.</Lead>
            <S n="1" title="VPC 만들기">
              <b>네트워크</b> 화면 → VPC 생성 → <b>가입 토큰</b>이 발급됩니다.
            </S>
            <S n="2" title="온프레 장비에 에이전트 설치 (가입 토큰 입력)">
              설치 후 가상IP를 부여받습니다. (별도 장비 노출 설정 불필요)
              <div style={{ margin: ".4rem 0 .2rem", fontWeight: 600, color: "#334155" }}>Windows (관리자 PowerShell)</div>
              <C>irm https://skynet.re.kr/download/install.ps1 | iex</C>
              <div style={{ margin: ".5rem 0 .2rem", fontWeight: 600, color: "#334155" }}>Linux</div>
              <C>curl -fsSL https://skynet.re.kr/download/install.sh | sudo bash</C>
              <Note><Terminal size={16} style={{ flexShrink: 0 }} /> 앤츠톡 플러그인의 “SkynetMesh” 카드에서 토큰만 넣고 원클릭 설치도 가능합니다.</Note>
            </S>
            <S n="3" title="연결 확인">
              <b>네트워크</b> 화면 피어 목록에 해당 장비가 <b>online</b>으로 뜨면 완료. 부여된 가상IP를 확인하세요.
            </S>
            <S n="4" title="기능에 연결">
              이후 각 기능에서 이 장비를 사용합니다 — <b>스토리지/서버리스</b>는 SSH 노드로, <b>데이터베이스</b>는 VPC 피어로 연결합니다(위 탭 참고).
            </S>
          </Card>
        )}

        {tab === "storage" && (
          <Card>
            <H><HardDrive size={18} /> 스토리지 — 온프레 디스크를 네트워크 드라이브로</H>
            <Lead>VPC로 연결된 온프레 박스의 디스크를 Samba 공유로 만들어, 내 PC에 네트워크 드라이브로 마운트합니다.</Lead>
            <S n="1" title="스토리지 노드 등록">
              <b>스토리지 → 네트워크 드라이브</b> 탭 → <b>노드 추가</b> → 가상IP, SSH 계정/개인키(또는 비밀번호) 입력.
            </S>
            <S n="2" title="디스크 확인 & 공유 만들기">
              노드의 <b>관리</b> → 디스크(lsblk) 확인 → <b>공유 만들기</b>에 공유 이름과 경로(예: <Mono>/mnt/disk1</Mono>) 입력.
              SSH로 Samba가 자동 구성되고 전용 계정/비밀번호가 발급됩니다.
            </S>
            <S n="3" title="내 PC에서 마운트">
              <div style={{ margin: ".2rem 0", fontWeight: 600, color: "#334155" }}>Windows</div>
              <C>{`net use Z: \\\\<가상IP>\\<공유명> /user:<계정> <비밀번호>`}</C>
              <div style={{ margin: ".4rem 0 .2rem", fontWeight: 600, color: "#334155" }}>Linux/Mac</div>
              <C>{`sudo mount -t cifs //<가상IP>/<공유명> /mnt/<공유명> -o username=<계정>,password=<비밀번호>`}</C>
            </S>
          </Card>
        )}

        {tab === "serverless" && (
          <Card>
            <H><Zap size={18} /> 서버리스 — 함수 실행 (중앙/온프레)</H>
            <Lead>Node.js·Python 함수를 작성해 격리 컨테이너에서 실행합니다. 실행 위치를 중앙 서버 또는 내 온프레 노드로 선택할 수 있습니다.</Lead>
            <S n="1" title="함수 생성">
              <b>서버리스 → 함수 생성</b> → 이름·런타임 선택. <b>실행 위치</b>를 중앙 또는 온프레 노드로 지정.
              <ul><li>핸들러(Node): <Mono>exports.handler = async (event) =&gt; {"{...}"}</Mono></li>
                <li>핸들러(Python): <Mono>def handler(event):</Mono></li></ul>
            </S>
            <S n="2" title="온프레 실행 준비 (해당 시)">
              온프레 노드는 <b>스토리지에서 SSH 노드로 등록</b>돼 있어야 하고, 그 박스에 <b>docker 또는 podman</b>이 설치돼 있어야 합니다.
            </S>
            <S n="3" title="실행">
              함수의 <b>실행</b> → 이벤트(JSON) 전달 → 반환값/로그/실행시간 확인. 온프레 선택 시 그 박스의 컨테이너에서 동작합니다.
            </S>
          </Card>
        )}

        {tab === "ansible" && (
          <Card>
            <H><Boxes size={18} /> 오케스트레이션 — Ansible</H>
            <Lead>여러 서버에 플레이북을 실행해 설정·배포를 자동화합니다. 대상은 SSH 접속 가능한 Linux 호스트입니다.</Lead>
            <S n="1" title="인벤토리 구성">
              <b>오케스트레이션 → Ansible</b> → 호스트 추가, 또는 <b>VPC 피어 가져오기</b>로 한 번에 등록. 각 호스트에 SSH 키/비번 설정(🔑).
            </S>
            <S n="2" title="플레이북 작성">
              <b>새 플레이북</b> → YAML 작성. <Mono>hosts: all</Mono> 로 선택한 호스트 전체를 대상으로 합니다.
            </S>
            <S n="3" title="실행">
              플레이북 선택 + 대상 호스트 체크 → <b>실행</b> → 콘솔에 ansible 출력(PLAY RECAP)과 실행 기록이 남습니다.
            </S>
          </Card>
        )}

        {tab === "db" && (
          <Card>
            <H><Database size={18} /> 데이터베이스 — 외부 · 온프레 PostgreSQL</H>
            <Lead>외부/온프레 PostgreSQL을 등록해 상태·커넥션·용량을 모니터링합니다. 온프레 PG는 VPC로 연결합니다.</Lead>
            <S n="1" title="온프레 PG 준비 (해당 시)">
              온프레 박스를 VPC에 연결한 뒤, PG가 가상IP에서 접속을 허용하도록 설정합니다.
              <ul><li><Mono>postgresql.conf</Mono>: <Mono>listen_addresses = '*'</Mono></li>
                <li><Mono>pg_hba.conf</Mono>: 가상IP 대역(100.77.0.0/16) 허용</li></ul>
            </S>
            <S n="2" title="DB 연결 등록">
              <b>데이터베이스 → DB 연결 추가</b> → 외부면 호스트 직접 입력, 온프레면 <b>VPC 피어 선택</b>(가상IP 자동) → 계정·DB명·비밀번호 입력.
              등록 시 연결 테스트가 수행됩니다.
            </S>
          </Card>
        )}

        {tab === "registry" && (
          <Card>
            <H><Box size={18} /> 컨테이너 레지스트리</H>
            <Lead>계정별 네임스페이스에 컨테이너 이미지를 push/pull 합니다. (레지스트리 화면 내 “사용 가이드” 탭에도 상세 안내)</Lead>
            <S n="1" title="네임스페이스 등록">
              <b>컨테이너 레지스트리 → 이미지</b> 탭 → 네임스페이스 등록 → 로그인 계정/비밀번호 발급.
            </S>
            <S n="2" title="로그인 & 푸시">
              <C>docker login skynet.re.kr -u &lt;네임스페이스&gt;</C>
              <C>docker tag &lt;이미지&gt; skynet.re.kr/&lt;네임스페이스&gt;/myapp:latest</C>
              <C>docker push skynet.re.kr/&lt;네임스페이스&gt;/myapp:latest</C>
            </S>
            <S n="3" title="풀">
              <C>docker pull skynet.re.kr/&lt;네임스페이스&gt;/myapp:latest</C>
            </S>
          </Card>
        )}

        {tab === "rtremote" && (
          <Card>
            <H><MonitorPlay size={18} /> RT Remote — 저지연 원격제어</H>
            <Lead>원격 PC 화면을 저지연으로 제어합니다. <b>RT Remote</b> 메뉴의 단계별 마법사를 따라가면 됩니다. 전체 진행 순서:</Lead>

            <div style={{ display: "flex", flexWrap: "wrap", gap: ".5rem", margin: "0 0 1.4rem", alignItems: "center" }}>
              {["호스트 PC 준비", "PC 선택", "스트리밍 켜기", "내 PC에 설치", "자동 페어링·접속"].map((t, i, a) => (
                <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#eff6ff", color: "var(--accent)", border: "1px solid #bfdbfe", borderRadius: 999, padding: "5px 12px", fontSize: ".82rem", fontWeight: 600 }}>
                    <span style={{ width: 18, height: 18, borderRadius: "50%", background: "var(--accent)", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 11 }}>{i + 1}</span>{t}
                  </span>
                  {i < a.length - 1 && <span style={{ color: "#cbd5e1", fontWeight: 700 }}>→</span>}
                </span>
              ))}
            </div>

            <S n="1" title="제어할 PC(호스트)에 에이전트 설치">
              그 PC에 <b>앤츠톡 → 플러그인 → SkynetMesh</b>를 설치해 VPC에 연결하면, 콘솔 호스트 목록에 <b>자동으로 나타납니다</b>. (제어할 PC마다 한 번만)
            </S>
            <S n="2" title="접속할 PC 선택">
              <b>RT Remote</b> 메뉴 ①단계 — 목록에 자동으로 뜬 PC 중 하나를 고릅니다.
            </S>
            <S n="3" title="스트리밍 켜기">
              ②단계 <b>[스트리밍 켜기]</b> → 그 PC에 처음 켤 때만 로그인 1회 → <b>“준비됨”</b>. (디스플레이/GPU 있는 PC에서 동작)
            </S>
            <S n="4" title="내 컴퓨터에 RT Remote 설치">
              ③단계 — <b>앤츠톡 → 플러그인 → RT Remote → 설치</b> (다운로드·압축해제·스킴등록 자동). 또는 내려받기 버튼.
            </S>
            <S n="5" title="자동 페어링 · 접속">
              ④단계 <b>[자동 페어링]</b>(PIN 입력 0회) → <b>[접속]</b>. 이후엔 <b>[접속] 한 번</b>이면 바로 연결됩니다.
            </S>
            <Note><Terminal size={16} style={{ flexShrink: 0 }} /><span>클라이언트를 직접 열면 “로컬 네트워크 검색 중” 화면이 도는데(VPC는 자동검색 대상 아님), 무시하고 콘솔 <b>[접속]</b>을 쓰면 가상 IP로 바로 연결됩니다.</span></Note>
          </Card>
        )}

        {tab === "billing" && (
          <Card>
            <H><CreditCard size={18} /> 결제 — SKY 토큰</H>
            <Lead>사용량을 SKY 토큰으로 자동 차감합니다. 보유 리소스는 시간당, 이벤트는 건당 과금됩니다.</Lead>
            <S n="1" title="차감 방식">
              <ul>
                <li><b>보유 리소스(시간당)</b>: 컴퓨트·VPC 피어·스토리지 공유·레지스트리·DB·함수</li>
                <li><b>이벤트(건당)</b>: 서버리스 호출, Ansible 실행</li>
              </ul>
              <b>결제</b> 화면 상단에서 잔액·시간당 요율·보유 리소스를 확인합니다. 잔액은 자동으로 갱신됩니다.
            </S>
            <S n="2" title="충전">
              <b>결제</b> 화면의 토큰 지갑에서 충전량 입력 또는 빠른충전(+100/+500/+1000)으로 SKY를 충전합니다. 거래내역에서 충전·사용 이력을 확인합니다.
            </S>
          </Card>
        )}
      </Content>
    </Page>
  )
}

export default Guide
